
<div class="global-background-div">

    <!-- 1 - Top section -->
    <div class="panel-type-light panel-content-centered vertical-padding main-width">
        <div class="panel-content-two-columns">
            <div class="panel-content-single-column product-column-left">
                <img class="software-image" src="assets/images/PC_Software.png" 
                    alt="{{this.languageService.Strings.alts.focusedon_overview}}" oncontextmenu="return false;" draggable="false"/>
            </div>
            <div class="panel-content-single-column product-column-right">
                <p class="text-title text-title-size">
                    {{languageService.Strings.softwarePageStrings.panel_1_string_1}}
                </p> 
                <p class="noraml-text-dark text-justify noraml-text-size">
                    {{languageService.Strings.softwarePageStrings.panel_1_string_2}}
                </p> 
                <p class="noraml-text-dark text-justify noraml-text-size">
                    {{languageService.Strings.softwarePageStrings.panel_1_string_3}}
                </p> 
            </div>
        </div>
    </div>





    <!-- 3 - FocusedON-BC - Detailed explanation -->
    <div class="panel-type-gray panel-content-centered vertical-padding main-width">
        <!-- Title -->
        <p class="text-title text-title-size">
            {{languageService.Strings.softwarePageStrings.panel_3_string_global_title}}
        </p>
        <!-- Video -->
        <img src="assets/videos/FocusedON_Video.gif" 
            alt="{{this.languageService.Strings.alts.focusedon_overview}}" class="responsive-video" oncontextmenu="return false;" draggable="false"/>
        <!-- Bullet points in two columns -->
        <div class="panel-content-two-columns-wrap">
            <div class="panel-content-two-columns-for-bullet-points"
                *ngFor="let string_value of languageService.Strings.softwarePageStrings.panel_3_string_list; let i = index" >
                <p class="noraml-text-dark text-left noraml-text-size bllet-point">
                    {{i+1}}
                </p>
                <p class="noraml-text-dark text-left noraml-text-size text-next-to-bullet-point">
                    {{string_value}}
                </p>
            </div>
        </div>
        <!-- Contact button -->
        <button 
            mat-raised-button
            color="primary"
            class="base_buttons"
            (click)="navigate('contact')" 
            button
            style="margin-top:30px;">
                {{languageService.Strings.softwarePageStrings.panel_3_string_demo}}
        </button>       
    </div>



    <!-- 2 - BC information -->
    <div class="panel-type-light panel-content-centered vertical-padding main-width">
        <div class="panel-content-single-column">
            <p class="text-title text-title-size">
                {{languageService.Strings.softwarePageStrings.panel_2_string_1}}
            </p> 
            <p class="noraml-text-dark text-justify noraml-text-size">
                {{languageService.Strings.softwarePageStrings.panel_2_string_2}}
                {{languageService.Strings.softwarePageStrings.panel_2_string_3}}
            </p>
            <p class="noraml-text-dark text-justify noraml-text-size">
                {{languageService.Strings.softwarePageStrings.panel_2_string_4}}
                {{languageService.Strings.softwarePageStrings.panel_2_string_5}}
            </p> 
            <p class="noraml-text-dark text-justify noraml-text-size">
                {{languageService.Strings.softwarePageStrings.panel_2_string_6}}
            </p> 
        </div>
        
        <!-- Bullet points in two columns -->
        <div class="panel-content-two-columns-papers">
            <div class="panel-content-two-columns-for-papers"
                *ngFor="let item of ItemList_parpers; let i = index" >

                <a class="paper-information-container" (click)="itemClicked(item)" (keydown)="onItemKeyDown($event, item)" tabindex="0">
                    <img class="paper-image" src="{{item.src}}" alt="{{item.title}}" oncontextmenu="return false;" draggable="false"/>
                    <div class="paper-text-container">
                        <div class="paper-text-top">
                            {{item.title}}
                        </div>
                        <p class="paper-text-bottom">
                            {{item.journal}} ({{item.date}})
                        </p>
                    </div>  
                </a>              
                
            </div>
        </div>

    </div>



</div>